<template>
  <div class="container">
    <div v-if="flow=='confirmation'" class="text-center pt-5">
      <h1>Confirmation</h1>
      <h5>Quantity: <el-input-number v-model="purchaseNum" :min="1" :max="10" label="Quantity"></el-input-number></h5>
      <h5>Subtotal: {{ unitPrice * purchaseNum }} TWD</h5>
      <h5>Paypal fees(4.5%): {{ fee }} TWD</h5>
      <h5>Total: {{ ( unitPrice * purchaseNum + fee).toFixed(0) }} TWD</h5>
      <h5><el-checkbox v-model='doAgreeTerms'>By placing a check in the box, you acknowledge that you voluntarily agree the recharge and purchasing terms</el-checkbox></h5>
      <div v-if="render && doAgreeTerms" id="paypal-button-container" />
    </div>
    <div v-if="flow=='thankyou'" class="text-center pt-5">
      <h1>Thank you for your support!</h1>
      <h1>After a while you can move to "My Credits" to see the changes of your credits.</h1>
    </div>
  </div>
</template>

<script>

import EventResource from '@/api/event'
const eventResource = new EventResource()

export default {
  name: 'PayCheckout',
  components: {},
  data: function() {
    return {
      flow: 'confirmation',
      render: false,
      title: '',
      unitPrice: 0,
      unitPoint: 0,
      purchaseNum: 1,
      doAgreeTerms: false,
      credentials: {
        sandbox: 'AWseVGGznSoVWcL3hwuJI0-iJnxXZNyzwzoumln4yz1E_XHg8EOsSU0Fv-yuI2euTQ1zV3VMeyrTEIxW',
        production: 'AfMl06IL_Rcgb__E63inbr1box7xeO3V04TI7WO6UIh0Lt92PFmxXt300x2gtfFApqMzt7R3Ji4_AyoE'
      },
      errorCodeMessage: {
        0: { 'type': 'success', 'title': ' Success', 'message': ' Success' },
        12: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 12)' },
        13: { 'type': 'error', 'title': 'Something went wrong', 'message': 'Please try again. (Error Code 13)' },
        23: { 'type': 'warning', 'title': 'Warning', 'message': 'Please try again. (Error Code 23)' }
      }
    }
  },
  computed: {
    fee: function() {
      var x = this.unitPrice * this.purchaseNum;
      return  Math.ceil((1.0 / (1.0-0.045) - 1.0) * x);
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === 'PayCheckout') {
        if (this.$route.params.item) {
          const item = this.$route.params.item;
          this.title = item.title;
          this.unitPrice = item.pay;
          this.unitPoint = item.point;
        }
        this.reload()
      } else if (from.name === 'PayCheckout') {
        this.render = false
      }
    },
    doAgreeTerms(newValue, oldValue) {
      if (newValue) {
        this.reload();
      }
    }
  },
  mounted: function() {
    if (this.$route.params.item) {
      const item = this.$route.params.item;
      this.title = item.title;
      this.unitPrice = item.pay;
      this.unitPoint = item.point;
    }

    this.reload()
  },
  methods: {
    reload() {
      this.render = false
      this.$nextTick(() => {
        this.render = true
        this.$nextTick(() => {
          this.initButton()
        })
      })
    },
    initButton() {
      const self = this
      var credential = '';
      if (process.env.NODE_ENV == 'production') {
        credential = this.credentials['production'];
      }
      else {
        credential = this.credentials['sandbox'];
      }
      const url = 'https://www.paypal.com/sdk/js?client-id=' + credential + '&currency=TWD';
      window.Vue.loadScript(url).then(() => {
        paypal.Buttons({
          createOrder: function(data, actions) {
            // This function sets up the details of the transaction, including the amount and line item details.
            return actions.order.create({
              purchase_units: [{
                amount: {
                  currency_code: "TWD",
                  value: parseInt( (self.unitPrice * self.purchaseNum + self.fee) )
                }
              }]
            })
          },
          onApprove: function(data, actions) {
            // This function captures the funds from the transaction.
            return actions.order.capture().then(function(details) {
              console.log('Transaction completed by ' + details.payer.name.given_name)
              console.log(details)
              const payItem = {
                pay: self.getTotalPay(),
                point: self.getTotalPoints(),
                paypalResourceId: details.id
              };
              self.sendData(payItem)
            })
          }
        }).render('#paypal-button-container')
      })
    },
    getTotalPay() {
      return this.unitPrice * this.purchaseNum + this.fee;
    },
    getTotalPoints() {
      return this.unitPoint * this.purchaseNum;
    },
    async sendData(item) {
      console.log('sendData')
      console.log(item)
      const { data } = await eventResource.createCredit({ 'item': item })
      const actionTitle = '儲值點數 '
      if (data.code === 0) {
        this.flow = 'thankyou'
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
      } else {
        this.messageNotify(
          actionTitle + this.errorCodeMessage[data.code]['title'],
          this.errorCodeMessage[data.code]['message'],
          this.errorCodeMessage[data.code]['type']
        )
        return false
      }
    },
    messageNotify(title, message, type) {
      this.$notify({
        title: title,
        dangerouslyUseHTMLString: true,
        message: `<div>${message}</div>`,
        type: type
      })
    }
  }
}

</script>
